export const setIsShippingActive = value => ({
    type: 'SHIPPING_ACTIVE',
    value
});
